export default {"src":"/_next/static/media/stethoscope_24.7076102d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};